
const state = {
  height: 0,
  width: 0,
  arrayFind: Array.prototype.find,
  threadShow: true,
  threadPosition: 'center',
  recorder: null
}

const getters = {
  height: state => {
    return state.height
  },
  width: state => {
    return state.width
  },
  arrayFind: state => {
    return state.Array.find
  },
  threadShow: state => {
    return state.threadShow
  },
  threadPosition: state => {
    return state.threadPosition
  },
  recorder: state => {
    return state.recorder
  }
}

const mutations = {
  SET_SIZE (state, data) {
    state.width = data.width
    state.height = data.height
  },
  TOGGLE_THREADVIEW (state) {
    state.threadShow = !state.threadShow
  },
  SET_THREADVIEW (state, data) {
    state.threadShow = data
  },
  SET_THREADPOSITION (state, data) {
    state.threadPosition = data
  },
  SET_RECORDER (state, data) {
    state.recorder = data
  }
}

const actions = {
  setWindowSize ({ commit }, data) {
    commit('SET_SIZE', data)
  },
  toggleThreadView ({ commit }) {
    commit('TOGGLE_THREADVIEW')
  },
  setThreadView ({ commit }, data) {
    commit('SET_THREADVIEW', data)
  },
  setThreadPosition ({ commit }, data) {
    commit('SET_THREADPOSITION', data)
  },
  setRecorder ({ commit }, data) {
    commit('SET_RECORDER', data)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
